import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import PropertyCard from './PropertyCard';
import publicListingsService from '../../services/publicListingsService';
import { text } from '../../theme/colors';

/**
 * Three other verified homes like this one. This is a courtesy, not the point of
 * the page: if the call fails or finds nothing, the section disappears rather
 * than showing an error the buyer can do nothing about.
 *
 * No heart here — saving belongs to the home the buyer is actually reading.
 */
export default function SimilarHomes({ id }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let live = true;
    setItems([]);
    publicListingsService.similar(id)
      .then((res) => { if (live) setItems(res?.data?.items || []); })
      .catch(() => { /* a missing suggestion list is not worth a banner */ });
    return () => { live = false; };
  }, [id]);

  if (items.length === 0) return null;

  return (
    <Box sx={{ mt: 5 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, color: text.primary, mb: 2 }}>
        Similar verified homes
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }, gap: 2.5 }}>
        {items.map((l) => <PropertyCard key={l.id} listing={l} />)}
      </Box>
    </Box>
  );
}
